module.exports = __webpack_public_path__ + "static/6-8e7d9d64850c91d2533325c123605115.jpg";